<template>
  <PopUpContents
    ref="popup"
    height="40rem"
  >
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="item-fluid p-3 m-2">
      <!-- ----------------- -->
      <!-- row 1 - title     -->
      <!-- ----------------- -->
      <div class="row h-40">
        <p class="bb-page-title mt-3 mb-2">{{ title }}</p>
      </div>
      <!-- -------------- -->
      <!--  row 3 - note  -->
      <!-- -------------- -->
      <div class="row mt-3 mb-3">
        <!-- ------- -->
        <!--  note   -->
        <!-- ------- -->
        <div class="row mt-2 mb-2">
          <div class="col form-group">
            <div class="form-floating">
              <textarea
                id="note"
                name="note"
                type="text"
                rows="8"
                placeholder="..."
                class="form-control bb-textarea-with-label bb-textarea-with-label-compact bb-card-description-control bb-campaign-note-control"
                v-model="note"
                autocomplete="off"
                :maxlength="maxLength"
              ></textarea>
              <label
                class="bb-float-label"
                for="note"
                >Note</label
              >
            </div>
          </div>
        </div>
        <!-- ------------------ -->
        <!--  character count   -->
        <!-- ------------------ -->
        <div
          class="row mt-2 d-flex justify-content-end bb-letter-count-control"
        >
          [ {{ note?.length ?? 0 }} of {{ maxLength }} ]
        </div>
        <!-- ---------- -->
        <!--  buttons   -->
        <!-- ---------- -->
        <div class="col-3">
          <div
            class="btn-group special mt-2"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              v-if="cancelButton"
              type="button"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              {{ cancelButton }}
            </button>
            <!-- ------------ -->
            <!--    add/ok    -->
            <!-- ------------ -->
            <button
              v-if="okButton"
              type="button"
              :disabled="isEmpty || !isChanged"
              @click="_confirm"
              class="btn btn-lg btn-primary"
            >
              {{ okButton }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'

export default {
  name: 'CampaignNoteDialog',
  components: {
    PopUpContents,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    title: undefined,
    subject: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: undefined,
    rejectPromise: undefined,
    resolvePromise: undefined,
    note: null,
    maxLength: 2000,
    original_note: null,
  }),
  //=====================================================================
  // computed
  //----------
  computed: {
    isEmpty() {
      return String(this.note || '').trim().length === 0
    },
    isChanged() {
      return this.note !== this.original_note
    },
  },
  //=====================================================================
  // methods
  //---------
  methods: {
    //================================================================================
    // show dialog
    //-------------
    show(opts = {}) {

      // passed parms
      this.title = opts.title
      this.subject = opts.subject
      this.message = opts.message
      this.note = opts.note

      this.original_note = this.note

      if (opts.okButton) {
        this.okButton = opts.okButton
      }
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //================================================================================
    // cancel
    //--------
    _cancel() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: true })
      }
    },
    //================================================================================
    // confirm
    //---------
    _confirm() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: false, ok: true, note: this.note })
      }
    },
  },
}
</script>
